import React, { Component } from 'react';
import Axios from 'axios';

import {Link} from 'react-router-dom';




class LoginSplash extends Component {
    constructor(props){
        super(props);

        this.state = {
            sponsersImgList : [],
            sponsersUrl:"",
            pageUrlVarify: false,
            pageLoader:true,
            allowAsExhibitor:false,
            allowAsSpeaker : false,
            allowAsLobbier : false,
        }
        
    }




    componentDidMount(){
        document.getElementById("profile_img").src = '/images/placeholder-profile.jpg';
    if(localStorage.getItem('roles')){
        var rolesArr = localStorage.getItem('roles').split(",");
        if(rolesArr.indexOf('-1') !== -1){
          this.setState({allowAsExhibitor:true});
        }
        /* uncomment this when you want to enable speaker dashboard link access */
        // if(rolesArr.indexOf('-6') !== -1){
        //   this.setState({allowAsSpeaker:true});
        // } 
        if(rolesArr.indexOf('-7') !== -1){
          this.setState({allowAsExhibitor:true});
        } 
    }

      
        
       Axios.get(`${global.config.requestUrl}exhibitor?eventId=${localStorage.getItem('eventId')}&type=2`)
        .then(res => {
            this.setState({sponsersImgList:res.data.data, sponsersUrl:res.data.logo, errorCode:res.data.errorCode})
            if(res.data.errorCode === 0){
                this.setState({pageUrlVarify : true, pageLoader:false})
                
            } else{
                this.setState({pageLoader:false})
            }
            
            /* console.log(res.data.data) */
            return res.data;
        })
        .catch(err => {
            console.log(err);
        });
        
    }
   


    render() {

            return (
                <React.Fragment>
               
                    <section className="bg2 signleScreen">
                            <div className="topHangerBrands">
                            {
                                this.state.errorCode !== 0 ? 
                                <ul>
                                    <li>
                                    <img src={process.env.PUBLIC_URL + '/images/top-brand-hanger-stand.png'} alt="" />
                                        <div className="brandLogoBx">
                                            <img src={process.env.PUBLIC_URL + '/images/top-brand-hanger-bx.png'} alt="" />
                                            <img src={process.env.PUBLIC_URL + '/images/sponser-dummy.png'} alt="" className="topBrandLogo" />
                                        </div>
                                    </li>
                                </ul>
                                :
                                <ul>
                                    { 
                                        this.state.sponsersImgList.map(sponsers => (
                                            <li key={sponsers.logo}>
                                            <img src={process.env.PUBLIC_URL + '/images/top-brand-hanger-stand.png'} alt="" />
                                                <div className="brandLogoBx">
                                                    <img src={process.env.PUBLIC_URL + '/images/top-brand-hanger-bx.png'} alt="" />
                                                    <img src={sponsers.logo} alt="" className="topBrandLogo" />
                                                </div>
                                            </li>
                                        ))
                                        
                                    }                            
                                </ul>    
                            }
                            
                                
                            </div>
                            {
                               this.state.pageLoader
                               ?
                               (
                            <div className="loaderWrp">
                                <div className="loaderInr">
                                    <img src={process.env.PUBLIC_URL + '/images/loader.gif'} alt="" />
                                </div>
                            </div>
                               )
                               :
                               <div className="splashWrp">
                                <div className="splashHeader">
                                    <img src={process.env.PUBLIC_URL + '/images/Heat_Treat_market_place.png'} alt="" />
                                </div>
                                <div className="splashListWrp">
                                    { 
                                    this.state.allowAsSpeaker
                                    ?
                                    (
                                    <div className="splashList">
                                        <div className="splashBx">
                                            <Link to="/fna/speaker/dashboard">
                                                <img src={process.env.PUBLIC_URL + '/images/splashSpeaker.png'} alt="" />
                                                <h3>Speaker Dashboard</h3>
                                            </Link>
                                        </div>
                                    </div> 
                                    )
                                    :
                                    null
                                    }
                                    { 
                                    this.state.allowAsExhibitor
                                    ?
                                    (
                                        <div className="splashList">
                                        <div className="splashBx">
                                            <Link to="/fna/exhibitor/dashboard">
                                                <img src={process.env.PUBLIC_URL + '/images/splashExhibit.png'} alt="" />
                                                <h3>Marketplace Dashboard</h3>
                                            </Link>
                                        </div>
                                    </div>
                                    )
                                    :
                                    null
                                    }
                                    { 
                                    this.state.allowAsLobbier
                                    ?
                                    ( 
                                    <div className="splashList">
                                        <div className="splashBx">
                                            <Link to="/fna/attendee/lobby">
                                                <img src={process.env.PUBLIC_URL + '/images/splashAtandee.png'} alt="" />
                                                <h3>Attendee Lobby</h3>
                                            </Link>
                                        </div>
                                    </div>
                                    )
                                    :
                                    null
                                    }
                                    <div className="splashList">
                                        <div className="splashBx">
                                            <Link to="/fna/attendee/exhibitHall">
                                                <img src={process.env.PUBLIC_URL + '/images/splashExhibitHall.png'} alt="" />
                                                <h3>Enter Marketplace</h3>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            
                    </section>
                </React.Fragment>
            )
        
        
         
    }
}
export default LoginSplash;
